import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import TopBar from "./TopBar";

interface SidebarProps {
  currentPage: string;
}

const Sidebar: React.FC<SidebarProps> = ({ currentPage }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    logout();
  };

  const handleNavigation = () => {
    // Close sidebar when navigating
    setIsOpen(false);
  };

  const handleDashboardNavigation = () => {
    setIsOpen(false);
    navigate("/dashboard");
  };

  const menuItems = [
    { path: "/dashboard", label: "Dashboard", icon: "🖥️" },
    { path: "/transactions", label: "Transactions", icon: "📊" },
    { path: "/accounts-setup", label: "Accounts Setup", icon: "⚙️" },
  ];

  // Admin/Root only menu items
  const adminMenuItems = [
    { path: "/users-setup", label: "Users Setup", icon: "👥" },
  ];

  // Root only menu items
  const rootMenuItems = [
    { path: "/business-setup", label: "Business Setup", icon: "🏢" },
  ];

  // Check if user has admin privileges
  const isAdmin = user?.role === "Root" || user?.role === "Admin";
  const isRoot = user?.role === "Root";

  return (
    <>
      {/* Overlays */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}

      {/* Top Bar */}
      <TopBar onMenuToggle={toggleSidebar} />

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-header">
          <div
            className="sidebar-brand"
            onClick={handleDashboardNavigation}
            style={{
              cursor: "pointer",
              transition: "opacity 0.2s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.opacity = "0.7";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.opacity = "1";
            }}
          >
            {/*<div className="brand-icon">💼</div>*/}
            <div className="brand-text">JSCP</div>
          </div>
          <button className="sidebar-close" onClick={toggleSidebar}>
            ✕
          </button>
        </div>

        <div className="sidebar-content">
          <nav className="sidebar-nav">
            <div className="nav-section">
              <div className="nav-section-title">Menu</div>
              {menuItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`nav-item ${
                    currentPage === item.path ? "active" : ""
                  }`}
                  onClick={() => {
                    toggleSidebar();
                    handleNavigation();
                  }}
                >
                  <span className="nav-icon">{item.icon}</span>
                  <span className="nav-label">{item.label}</span>
                </Link>
              ))}
              {isAdmin &&
                adminMenuItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-item ${
                      currentPage === item.path ? "active" : ""
                    }`}
                    onClick={() => {
                      toggleSidebar();
                      handleNavigation();
                    }}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                  </Link>
                ))}
              {isRoot &&
                rootMenuItems.map((item) => (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`nav-item ${
                      currentPage === item.path ? "active" : ""
                    }`}
                    onClick={() => {
                      toggleSidebar();
                      handleNavigation();
                    }}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-label">{item.label}</span>
                  </Link>
                ))}
            </div>

            <div className="nav-section">
              <div className="nav-section-title">Account</div>
              <Link
                to="/settings"
                className={`nav-item ${
                  currentPage === "/settings" ? "active" : ""
                }`}
                onClick={() => {
                  toggleSidebar();
                  handleNavigation();
                }}
              >
                <span className="nav-icon">👤</span>
                <span className="nav-label">User Settings</span>
              </Link>
              <button className="nav-item nav-logout" onClick={handleLogout}>
                <span className="nav-icon">⏻</span>
                <span className="nav-label">Sign out</span>
              </button>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
